import * as api from './files.api';
import * as queries from './files.queries';
import * as mutations from './files.mutations';

export * from './files.api';
export * from './files.mutations';
export * from './files.queries';

export default { ...api, ...queries, ...mutations };
